@if (hasVideos) {
  <wc-wrapper [contentWrapper]="wrapper">
    <div sd-component-wrapper-component>
      <wc-skeeper-shoppable-content
        [data]="data"
        [hideNavigationControls]="false"
        (hasVideos)="checkHasVideos($event)"
      />
    </div>
  </wc-wrapper>
}
